export function Step4Quotation({ formData, quotationDetails, t }) {
    if (!quotationDetails) {
        return null;
    }

    const formatVehicles = () => {
        return formData.vehicles.map((v, index) => (
            <li key={index}>
                {t(`stepper.vehicle_type.options.${v.vehicleType}`)}
                {v.vehicleLength !== 'bike_moto' ? ` (${v.vehicleLength}) ` : ' '}
                {v.services && v.services !== 'None' && (
                    <span>
                        - {t('stepper.additional_services.label')}: {t(`stepper.additional_services.${v.services}`)}
                    </span>
                )}
            </li>
        ));
    };

    const getReturnTime = () => {
        if (formData.pickup_place === 'station') return formData.train_arrival_time;
        if (formData.pickup_place === 'harbour') return formData.disembark_time;
        if (['city', 'other'].includes(formData.pickup_place)) return formData.pickup_time;
        return '';
    };

    return (
        <div className="step-content">
            <h3>{t('quoteModal.title')}</h3>
            <div className="quote-summary p-3 mb-4 rounded border">
                <h5>{t('quoteModal.summaryTitle')}</h5>
                <p>
                    <strong>Checkin:</strong> {formData.checkin_date} {formData.checkin_time}
                </p>
                <p>
                    <strong>Checkout:</strong> {formData.checkout_date} {formData.checkout_time}
                </p>
                <p>
                    <strong>{t('quoteModal.duration')}:</strong> {quotationDetails.numberOfDays} {t('quoteModal.days')}
                </p>

                <p className="mt-3">
                    <strong>{t('quoteModal.vehicles')}:</strong>
                </p>
                <ul>{formatVehicles()}</ul>

                {formData.has_transfer && (
                    <>
                        <h5 className="mt-4">{t('stepper.transfer_details_title')}</h5>
                        <div className="rounded bg-light px-3 py-2 mt-2 d-inline-flex align-items-center">
                            <i className="fi fi-rs-time-fast me-2 text-primary d-flex"></i>
                            <p className="mb-0">{t('quoteModal.distance_time')}</p>
                        </div>

                        <div className="row g-2 mt-3">
                            {(formData.transfer_type === 'outbound' ||
                                formData.transfer_type === 'outbound_return') && (
                                <div className="col-12 col-md-6">
                                    <h6 className="badge text-bg-secondary">{t('stepper.outbound_transfer.title')}</h6>
                                    <p>
                                        <strong>{t('stepper.passengers_outbound.label')}:</strong>{' '}
                                        {formData.passengers_outbound}
                                    </p>
                                    <p>
                                        <strong>{t('stepper.dropoff_place.label')}:</strong>{' '}
                                        {formData.dropoff_place === 'other'
                                            ? formData.dropoff_place_detail
                                            : t('contact.fields.transfer.' + formData.dropoff_place)}
                                    </p>
                                    {['city', 'other'].includes(formData.dropoff_place) &&
                                        formData.dropoff_place_detail && (
                                            <p>
                                                <strong>{t('stepper.dropoff_place_detail.label')}:</strong>{' '}
                                                {formData.dropoff_place_detail}
                                            </p>
                                        )}
                                    {formData.dropoff_place === 'harbour' && (
                                        <p>
                                            <strong>{t('stepper.embark_detail.label')}:</strong>{' '}
                                            {formData.embark_detail}
                                        </p>
                                    )}
                                </div>
                            )}

                            {(formData.transfer_type === 'return' || formData.transfer_type === 'outbound_return') && (
                                <div className="col-12 col-md-6">
                                    <h6 className="badge text-bg-secondary">{t('stepper.return_transfer.title')}</h6>
                                    <p>
                                        <strong>{t('stepper.passengers_return.label')}:</strong>{' '}
                                        {formData.passengers_return}
                                    </p>
                                    <p>
                                        <strong>{t('stepper.pickup_place.label')}:</strong>{' '}
                                        {formData.pickup_place === 'other'
                                            ? formData.pickup_place_detail
                                            : t('contact.fields.transfer.' + formData.pickup_place)}
                                    </p>
                                    {['city', 'other'].includes(formData.pickup_place) &&
                                        formData.pickup_place_detail && (
                                            <p>
                                                <strong>{t('stepper.pickup_place_detail.label')}:</strong>{' '}
                                                {formData.pickup_place_detail}
                                            </p>
                                        )}
                                    {formData.pickup_place === 'harbour' && (
                                        <p>
                                            <strong>{t('stepper.disembark_detail.label')}:</strong>{' '}
                                            {formData.disembark_detail}
                                        </p>
                                    )}
                                    <p>
                                        <strong>{t('stepper.return_transfer_time.label')}:</strong> {getReturnTime()}
                                    </p>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>

            <div className="text-center mt-4">
                <h6 className="mt-4">{t('quoteModal.quoteTitle')}</h6>
                <p className="fs-4 mb-0">
                    <strong>
                        {t('quoteModal.total')}: €{quotationDetails.total_quotation.toFixed(2)}
                    </strong>
                </p>
                <p>
                    {t('quoteModal.instead_of')}{' '}
                    <span style={{ textDecoration: 'line-through', textDecorationThickness: '0.75px' }}>
                        €{(Math.round(quotationDetails.total_quotation * 1.1 * 100) / 100).toFixed(2)}
                    </span>
                    *
                </p>
                {quotationDetails.numberOfDays < 3 && (
                    <>
                        <i className="bi bi-exclamation-triangle text-warning me-1" style={{ fontSize: '15px' }}></i>
                        <span style={{ fontSize: '10px' }}>{t('contact.fields.disclaimer_minimum_payment')}</span>
                    </>
                )}
                <div className="text-muted">
                    <span style={{ fontSize: '10px' }}>* {t('quoteModal.no_reservation_price_note')}</span>
                </div>
            </div>
        </div>
    );
}
